import { takeEvery } from 'redux-saga/effects';
import { load } from 'sdk/processingWindow';
import { LOAD } from 'model/processingWindow';
import { callAction } from '../util';

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      type: LOAD,
      api: load,
    })
  );
}
